var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import theme from '../../../theme';
import { Button, ScreenReaderText } from 'syf-component-library/ui/atoms';
import { t } from '../../../strings/i18n/i18n';
import { loadMoreTransactions, sortTransactions } from '../../../redux/allDisputes/allDisputes.slice';
import { generateUUID } from 'syf-js-utilities';
import { renderSortByText } from './helpers';
import TableHeaderRow from './TableHeaderRow';
import { TableDataRow } from './TableDataRow';
import TableFAQ from './TableFAQ';
var ButtonContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border-bottom: 1px solid ", ";\n  display: flex;\n  justify-content: center;\n"], ["\n  border-bottom: 1px solid ", ";\n  display: flex;\n  justify-content: center;\n"])), theme.colors.lightGrey);
var DisputesTable = function () {
    var dispatch = useDispatch();
    var _a = useSelector(function (_a) {
        var allDisputes = _a.allDisputes;
        return allDisputes;
    }), transactions = _a.transactions, paginatedTransactions = _a.paginatedTransactions, currentSorter = _a.currentSorter, sorterOrder = _a.sorterOrder;
    var shouldDisplayLoadMoreButton = transactions.length - paginatedTransactions.length > 0;
    var handleToggleSort = function (sorter) {
        dispatch(sortTransactions(sorter));
    };
    var handleLoadMore = function () {
        dispatch(loadMoreTransactions());
    };
    return (_jsxs("div", __assign({ "data-testid": "disputes-table", "data-cy": "disputes-table" }, { children: [_jsx(ScreenReaderText, { children: renderSortByText(currentSorter, sorterOrder[currentSorter]) }), _jsx(TableHeaderRow, { sorters: sorterOrder, onToggleSort: handleToggleSort }), _jsx("div", __assign({ "data-cy": "disputes-table-rows" }, { children: paginatedTransactions.map(function (data) { return (_jsx(TableDataRow, { data: data }, generateUUID())); }) })), shouldDisplayLoadMoreButton && (_jsx(ButtonContainer, { children: _jsx(Button, __assign({ dataCy: "disputes-load-more", buttonType: "ghost", className: "ensightencustomevent digitaldisputeevent", "data-title": "load-more", "data-reason": "header-nav", "data-object": "button", onClick: handleLoadMore }, { children: t('button.loadMore') })) })), _jsx(TableFAQ, {})] })));
};
export default DisputesTable;
var templateObject_1;
//# sourceMappingURL=index.js.map